import platform_type from "dictionaries/platform_type.json";
import createOptions from "utils/createOptions";

export default createOptions(platform_type);
